export function formatShortAddress(address: string, startCharCount = 6, endCharCount = 4) {
  return `${address.substr(0, startCharCount)}...${address.substr(address.length - endCharCount)}`;
}
